'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Swimming = function (_PureComponent) {
  (0, _inherits3.default)(Swimming, _PureComponent);
  function Swimming() {
    (0, _classCallCheck3.default)(this, Swimming);
    return (0, _possibleConstructorReturn3.default)(this, (Swimming.__proto__ || (0, _getPrototypeOf2.default)(Swimming)).apply(this, arguments));
  }
  (0, _createClass3.default)(Swimming, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M21.925 25.583c-2.737 0-5.782-.892-9.05-2.65l-.04-.022c-.163-.08-1.78-.858-3.894-1.223-2.74-.448-4.98.037-6.638 1.445A1.4 1.4 0 0 1 .492 21c2.312-1.963 5.314-2.66 8.91-2.07 1.95.336 3.966 1.075 4.794 1.55l.005-.01c2.856 1.536 5.454 2.316 7.724 2.316 2.66 0 3.927-1.117 3.94-1.128.56-.507 1.44-.49 1.962.06a1.38 1.38 0 0 1-.005 1.936c-.078.08-1.958 1.928-5.897 1.928z'
      }), _react2.default.createElement('path', {
        d: 'M30.462 12.6c-.448-.495-1.79-.79-2.438-.887s-2.017.384-2.135.106c-.248-.582-1.047-.842-1.047-.842s-2.14-1.583-3.734-2.87C19.515 6.82 17.427 6.33 16.93 6.43s-2.277 2.54-3.018 3.736c-.742 1.194-.79 2.138-.936 2.834s-1.486 1.644-2.528 1.945c-.674.195-3.19 1.868-5.034 3.082 1.234-.17 2.563-.147 3.99.086 1.95.337 3.966 1.076 4.794 1.55l.005-.01c1.64.884 3.186 1.487 4.644 1.866-.133-.38-.28-.724-.342-.93-.233-.758-.244-1.26-.244-1.26.846.037 2.236-.094 3.08-.295s2.18-1.795 2.428-2.193c.247-.398.195-1.243-.056-2.235s-1.395-1.238-2.34-1.533-2.133.8-2.79 1.293c-.66.492-.63.804-.728 1.25s-1.04 1.196-1.338 1.197c-.298 0-.4-.446-.4-.446s.15-.298.445-1.094c.297-.796-.103-1.64.787-3.082s.44-2.187.44-2.187l.148-.547c.4.496 2.835 1.234 4.228 1.776s2.648 1.844 3.186 2.276c.51.41.306.548.494.692.848.65 2.99 1.583 3.534 1.234s-1.148-.634-1.55-.79c-.4-.154-.49-.545.907-.308s2.926.296 3.224-.25c.297-.548-1.048-.99-1.497-1.487z'
      }));
    }
  }]);
  return Swimming;
}(_react.PureComponent);
Swimming.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Swimming;